import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SolanaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.94916 10.6322C4.02158 10.5552 4.12115 10.5103 4.22676 10.5103H13.8038C13.9788 10.5103 14.0663 10.7348 13.9426 10.8664L12.0507 12.8779C11.9783 12.9549 11.8788 12.9998 11.7731 12.9998H2.19608C2.02107 12.9998 1.93357 12.7753 2.05728 12.6437L3.94916 10.6322Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.94901 3.12191C4.02444 3.04491 4.12401 3 4.2266 3H13.8037C13.9787 3 14.0662 3.22457 13.9425 3.35611L12.0506 5.36766C11.9782 5.44466 11.8786 5.48957 11.773 5.48957H2.19593C2.02092 5.48957 1.93342 5.265 2.05713 5.13346L3.94901 3.12191Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.0507 6.85287C11.9783 6.77587 11.8788 6.73096 11.7731 6.73096H2.19608C2.02107 6.73096 1.93357 6.95553 2.05728 7.08707L3.94916 9.09862C4.02158 9.17562 4.12115 9.22053 4.22676 9.22053H13.8038C13.9788 9.22053 14.0663 8.99596 13.9426 8.86442L12.0507 6.85287Z"
		></path>
	</svg>
))
